import categories from './categories/routes'
import disciplines from './disciplines/routes'
import media from './media/routes'

const RiderLayout = () => import('./layouts/RiderLayout.vue')

const RiderIndex = () => import('./views/RiderIndex.vue')
const RiderCreate = () => import('./views/RiderCreate.vue')
const RiderEdit = () => import('./views/RiderEdit.vue')

export default [
  {
    path: 'riders',
    name: 'riders.index',
    component: RiderIndex
  },
  {
    path: 'riders/create',
    name: 'riders.create',
    component: RiderCreate
  },
  {
    path: 'riders/:riderId(\\d+)',
    component: RiderLayout,
    children: [
      {
        path: '',
        name: 'riders.edit',
        component: RiderEdit
      },
      ...media
    ]
  },
  ...categories,
  ...disciplines
]
